import { render, staticRenderFns } from "./registro_edicion_editoriales.vue?vue&type=template&id=4473851a&scoped=true"
import script from "./registro_edicion_editoriales.vue?vue&type=script&lang=js"
export * from "./registro_edicion_editoriales.vue?vue&type=script&lang=js"
import style0 from "./registro_edicion_editoriales.vue?vue&type=style&index=0&id=4473851a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4473851a",
  null
  
)

export default component.exports